import React from "react";
import { Route, BrowserRouter, Routes } from "react-router-dom";

import Main from "./pages/Main/Main";
import Manager from "./pages/Manager/Manager";
import User from "./pages/User/User";

const Router = () => {
   return(
       <BrowserRouter>
        <Routes>
          <Route path="/" element={<Main />}/>
          <Route path="/manager" element={<Manager />}/>
          <Route path="/login" element={<User />}/>
        </Routes>
       </BrowserRouter>
   )
}

export default Router;